<section class="pricing-stack">
  <section class="pricing-card" *ngIf="isSuperadmin()">
    <div class="pricing-card-head">
      <div>
        <div class="pricing-eyebrow">{{ pageEyebrow() }}</div>
        <h2>{{ pageTitle() }}</h2>
        <p class="pricing-lead">{{ pageDescription() }}</p>
      </div>
    </div>

    <div class="pricing-stats-grid">
      <article class="pricing-stat-card">
        <span>Plans actifs</span>
        <strong>{{ superadminActivePlanCount() }}</strong>
        <small>Catalogue visible dans la vue superadmin</small>
      </article>
      <article class="pricing-stat-card">
        <span>Compagnies clientes</span>
        <strong>{{ superadminCustomerCompanyCount() }}</strong>
        <small>Compagnies avec au moins une souscription active</small>
      </article>
      <article class="pricing-stat-card">
        <span>Licences vendues</span>
        <strong>{{ totalSoldSeats() }}</strong>
        <small>Volume facture tous plans confondus</small>
      </article>
      <article class="pricing-stat-card">
        <span>MRR global</span>
        <strong>{{ globalMonthlyRecurringRevenue() | currency: 'EUR' : 'symbol' : '1.0-0' : 'fr' }}</strong>
        <small>Revenu mensuel recurrent de la plateforme</small>
      </article>
    </div>
  </section>

  <ng-container *ngIf="isSuperadmin(); else companyAdminView">
    <section class="pricing-card">
      <div class="pricing-card-head">
        <div>
          <div class="pricing-eyebrow">Plans</div>
          <h2>Catalogue, souscriptions et MRR par plan</h2>
          <p class="pricing-lead">
            Chaque section correspond a un plan actif, liste les compagnies abonnees et recalcule les totaux
            sur la base des licences achetees.
          </p>
        </div>
      </div>

      <div class="pricing-plan-section-list" *ngIf="superadminPlanSections().length; else noPlanSection">
        <article class="pricing-plan-section" *ngFor="let plan of superadminPlanSections(); trackBy: trackPlanSection">
          <div class="pricing-plan-section-head">
            <div>
              <div class="pricing-plan-title-row">
                <h3>{{ plan.name }}</h3>
                <strong *ngIf="plan.unitPriceEuros !== null">
                  {{ formatCurrency(plan.unitPriceEuros) }} / licence / mois
                </strong>
              </div>
              <p class="pricing-plan-description">{{ plan.description }}</p>
            </div>
            <div class="pricing-plan-revenue">
              <span>MRR du plan</span>
              <strong>{{ formatCurrency(plan.totalMrrEuros) }}</strong>
            </div>
          </div>

          <div class="pricing-plan-summary-grid">
            <article class="pricing-mini-stat">
              <span>Compagnies abonnees</span>
              <strong>{{ plan.subscribedCompanyCount }}</strong>
            </article>
            <article class="pricing-mini-stat">
              <span>Licences vendues</span>
              <strong>{{ plan.totalLicenses }}</strong>
            </article>
            <article class="pricing-mini-stat">
              <span>MRR total</span>
              <strong>{{ formatCurrency(plan.totalMrrEuros) }}</strong>
            </article>
          </div>

          <div class="pricing-plan-meta-grid">
            <div class="pricing-plan-detail-block">
              <h4>Fonctionnalites incluses</h4>
              <div class="pricing-pill-list">
                <span class="pricing-pill" *ngFor="let capability of plan.capabilityLabels">{{ capability }}</span>
              </div>
            </div>

            <div class="pricing-plan-detail-block">
              <h4>Restrictions et regles</h4>
              <div class="pricing-pill-list">
                <span class="pricing-pill pricing-pill-muted" *ngFor="let restriction of plan.restrictionLabels">
                  {{ restriction }}
                </span>
              </div>
            </div>

            <div class="pricing-plan-scope">
              <strong>Positionnement</strong>
              <span>{{ plan.accessScope }}</span>
            </div>
          </div>

          <div class="pricing-table-wrap">
            <div class="pricing-company-grid" role="table" [attr.aria-label]="'Souscriptions ' + plan.name">
              <div class="pricing-company-grid__row pricing-company-grid__row--head" role="row">
                <div role="columnheader">Compagnie</div>
                <div role="columnheader">Licences</div>
                <div role="columnheader">MRR</div>
                <div role="columnheader">Contact prenom</div>
                <div role="columnheader">Contact nom</div>
                <div role="columnheader">Contact email</div>
                <div role="columnheader">Telephone</div>
                <div role="columnheader">Poste</div>
                <div role="columnheader">Username contact</div>
              </div>

              <div
                class="pricing-company-grid__row"
                role="row"
                *ngFor="let subscription of plan.subscriptions; trackBy: trackPlanSubscription"
              >
                <div role="cell">
                    <div class="pricing-table-primary">{{ subscription.companyName }}</div>
                    <div class="pricing-table-secondary">{{ plan.name }}</div>
                </div>
                <div role="cell">{{ subscription.licenseCount }}</div>
                <div role="cell" class="pricing-table-price">{{ formatCurrency(subscription.mrrEuros) }}</div>
                <div role="cell">{{ subscription.contactFirstName }}</div>
                <div role="cell">{{ subscription.contactLastName }}</div>
                <div role="cell">{{ subscription.contactEmail }}</div>
                <div role="cell">{{ subscription.contactPhone }}</div>
                <div role="cell">{{ subscription.contactJobTitle }}</div>
                <div role="cell">{{ subscription.contactUsername }}</div>
              </div>

              <div class="pricing-empty pricing-company-grid__empty" *ngIf="!plan.subscriptions.length">
                Aucune compagnie abonnee a ce plan.
              </div>

              <div
                class="pricing-company-grid__row pricing-company-grid__row--total"
                role="row"
                *ngIf="plan.subscriptions.length"
              >
                <div role="cell">
                    <div class="pricing-table-primary">Total compagnies : {{ plan.subscribedCompanyCount }}</div>
                </div>
                <div role="cell">{{ plan.totalLicenses }}</div>
                <div role="cell" class="pricing-table-price">{{ formatCurrency(plan.totalMrrEuros) }}</div>
                <div role="cell" class="pricing-table-muted">—</div>
                <div role="cell" class="pricing-table-muted">—</div>
                <div role="cell" class="pricing-table-muted">—</div>
                <div role="cell" class="pricing-table-muted">—</div>
                <div role="cell" class="pricing-table-muted">—</div>
                <div role="cell" class="pricing-table-muted">—</div>
              </div>
            </div>
          </div>
        </article>
      </div>

      <ng-template #noPlanSection>
        <div class="pricing-empty">Aucun plan actif a afficher.</div>
      </ng-template>
    </section>

    <section class="pricing-card">
      <div class="pricing-card-head">
        <div>
          <div class="pricing-eyebrow">Compagnies</div>
          <h2>MRR par compagnie</h2>
          <p class="pricing-lead">
            Lecture transversale des compagnies abonnees, de leurs plans factures et de leur revenu mensuel total.
          </p>
        </div>
      </div>

      <div class="pricing-table-wrap">
        <table class="pricing-table">
          <thead>
            <tr>
              <th>Compagnie</th>
              <th>Plans actifs</th>
              <th>Licences achetees</th>
              <th>MRR</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let company of subscribedCompanies(); trackBy: trackCompany">
              <td>
                <div class="pricing-table-primary">{{ company.name }}</div>
              </td>
              <td>
                <div class="pricing-subscription-list">
                  <div class="pricing-subscription-item" *ngFor="let subscription of companySubscriptionDetails(company)">
                    <strong>{{ subscription.name }}</strong>
                    <span>{{ subscription.seatCount }} licence(s)</span>
                  </div>
                </div>
              </td>
              <td>{{ companyTotalLicenses(company) }}</td>
              <td class="pricing-table-price">
                {{ formatCurrency(company.monthlyTotalEuros || 0) }}
              </td>
            </tr>
            <tr *ngIf="!subscribedCompanies().length">
              <td colspan="4" class="pricing-empty">Aucune compagnie abonnee a afficher.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ng-container>

  <ng-template #companyAdminView>
    <section class="pricing-card">
      <div class="pricing-card-head">
        <div>
          <div class="pricing-eyebrow">Plans souscrits</div>
          <h2>Plans souscrits et allocations</h2>
          <p class="pricing-lead">
            Consultez vos allocations soit en vue detaillee par plan, soit en vue compacte pour comparer rapidement les quotas.
          </p>
        </div>
        <div class="pricing-view-tabs" role="tablist" aria-label="Mode d affichage des allocations">
          <button
            class="pricing-view-tab"
            type="button"
            role="tab"
            [attr.aria-selected]="companyAdminViewMode() === 'detailed'"
            [class.pricing-view-tab--active]="companyAdminViewMode() === 'detailed'"
            (click)="setCompanyAdminViewMode('detailed')"
          >
            Vue detaillee allocations
          </button>
          <button
            class="pricing-view-tab"
            type="button"
            role="tab"
            [attr.aria-selected]="companyAdminViewMode() === 'compact'"
            [class.pricing-view-tab--active]="companyAdminViewMode() === 'compact'"
            (click)="setCompanyAdminViewMode('compact')"
          >
            Vue compacte allocation
          </button>
        </div>
      </div>

      <ng-container *ngIf="companyAdminViewMode() === 'detailed'; else compactAllocationView">
        <div class="pricing-plan-grid">
          <article class="pricing-plan-card" *ngFor="let plan of visiblePlanCards(); trackBy: trackPlan">
            <div class="pricing-plan-header">
              <div>
                <h3>{{ plan.name }}</h3>
                <small class="pricing-plan-caption">Vue de votre compagnie</small>
              </div>
            </div>

            <p>{{ plan.description }}</p>

            <div class="pricing-plan-allocations">
              <div>
                <span>Total</span>
                <strong>{{ plan.total }}</strong>
              </div>
              <div>
                <span>Allouees</span>
                <strong>{{ plan.used }}</strong>
              </div>
              <div>
                <span>Restantes</span>
                <strong>{{ plan.remaining }}</strong>
              </div>
            </div>

            <div class="pricing-plan-detail-block">
              <h4>Fonctionnalites incluses</h4>
              <ul>
                <li *ngFor="let capability of plan.capabilityLabels">{{ capability }}</li>
              </ul>
            </div>

            <div class="pricing-plan-detail-block">
              <h4>Restrictions et regles</h4>
              <ul>
                <li *ngFor="let restriction of plan.restrictionLabels">{{ restriction }}</li>
              </ul>
            </div>

            <div class="pricing-plan-scope">
              {{ plan.accessScope }}
            </div>
          </article>
        </div>
      </ng-container>

      <ng-template #compactAllocationView>
        <div class="pricing-table-wrap">
          <table class="pricing-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Total achete</th>
                <th>Alloue</th>
                <th>Restant</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let plan of visiblePlanCards(); trackBy: trackPlan">
                <td>
                  <div class="pricing-table-primary">{{ plan.name }}</div>
                  <div class="pricing-table-secondary">{{ plan.capabilityLabels.join(' • ') }}</div>
                </td>
                <td>{{ plan.total }}</td>
                <td>{{ plan.used }}</td>
                <td>{{ plan.remaining }}</td>
              </tr>
              <tr *ngIf="!visiblePlanCards().length">
                <td colspan="4" class="pricing-empty">Aucune licence achetee pour cette compagnie.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>

      <div class="pricing-empty" *ngIf="!visiblePlanCards().length">
        Aucun plan actif a afficher.
      </div>

      <div class="pricing-admin-note">
        Attribuez ces licences depuis la page Users. Si le nombre restant devient insuffisant, contactez le superadmin pour ajuster les volumes de votre compagnie.
      </div>
    </section>
  </ng-template>
</section>
